export default __webpack_public_path__ + "static/media/46_2_2.8093dbfb.png";